import { SVGProps } from 'react'

const NewTwitterIconSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M15.1705 1.875H17.9272L11.9047 8.75833L18.9897 18.125H13.4422L9.09717 12.4442L4.12554 18.125H1.36721L7.80887 10.7625L1.01221 1.875H6.70054L10.628 7.0675L15.1705 1.875ZM14.203 16.475H15.7305L5.87054 3.43833H4.23137L14.203 16.475Z"
      fill="white"
    />
  </svg>
)

export default NewTwitterIconSvg
